// Provisional (Phase 1) copy. Decision points are drafts to be confirmed in Phase 3.

export const DECISION_KINDS = {
  none: { label: "No purchase", tone: "text-o-dim" },
  purchase: { label: "Purchasing decision", tone: "text-o-accent" },
  authorization: { label: "New authorization", tone: "text-o-text" },
  tbc: { label: "To be confirmed", tone: "text-o-dim italic" },
};

export const STAGES = [
  {
    id: "understand", index: "01", label: "Understand", summary: "You bring one problem.",
    experiences: "You describe one problem your business keeps dealing with, in your own terms and without needing to know its cause.",
    carries: "Ordo Intelligence listens for the structure behind the problem: the people, responsibilities, knowledge, authority, and technology involved.",
    receives: "A shared statement of the situation and a clear view of whether a diagnostic is appropriate.",
    decision: { kind: "none", text: "An initial conversation. No purchase is involved at this stage." },
  },
  {
    id: "diagnose", index: "02", label: "Diagnose", summary: "We investigate what needs to change.",
    experiences: "A focused investigation of your actual situation, with your people and your existing arrangements.",
    carries: "The diagnostic method: investigating what actually needs to change and determining an appropriate response.",
    receives: "A diagnosis and a recommended response. The response may involve software, advisory, or implementation, or none of these.",
    decision: { kind: "purchase", text: "Ordo Diagnostic is purchased on its own, independently of any software or implementation." },
    exit: true,
  },
  {
    id: "build", index: "03", label: "Build", summary: "The response is fitted to you.",
    experiences: "The chosen response is shaped around your organization rather than the other way around.",
    carries: "Fitted software, architectural advisory, or implementation work, as the diagnosis warrants.",
    receives: "An intervention fitted to your situation, which may include one or more applied software capabilities.",
    decision: { kind: "authorization", text: "Proceeding to build is a separate decision. Nothing is built without a new authorization." },
  },
  {
    id: "connect", index: "04", label: "Connect", summary: "It joins your actual arrangements.",
    experiences: "The intervention is connected to the people, systems, and responsibilities it is meant to serve.",
    carries: "Implementation and integration into your existing arrangements.",
    receives: "An intervention in use within your organization.",
    decision: { kind: "tbc", text: "Whether connection is covered by the build authorization or agreed separately will be confirmed." },
  },
  {
    id: "improve", index: "05", label: "Improve", summary: "It continues to be reconsidered.",
    experiences: "As circumstances change, the arrangement is examined again rather than left to drift.",
    carries: "Continuing support and reconsideration of what has been established.",
    receives: "Continuing support, and improvements as your situation changes.",
    decision: { kind: "authorization", text: "Continuing support is a separate, optional arrangement." },
  },
];

export const STAGE_IDS = STAGES.map((s) => s.id);

export const BOUNDARIES = [
  { title: "The diagnostic stands on its own", text: "Ordo Diagnostic can be purchased independently of any software or implementation." },
  { title: "You may stop after diagnosis", text: "A customer may choose not to proceed to implementation." },
  { title: "Software can be purchased directly", text: "Where appropriate, an applied software capability can be acquired without a diagnostic." },
];

export const DELIVERS = [
  { label: "Diagnosis", stage: "Diagnose", text: "An investigation of what actually needs to change." },
  { label: "Fitted software", stage: "Build", text: "Applied capabilities fitted to the situation." },
  { label: "Architectural advisory", stage: "Build", text: "Guidance on how the arrangement should be structured." },
  { label: "Implementation", stage: "Connect", text: "Connecting the response to real people and systems." },
  { label: "Continuing support", stage: "Improve", text: "Keeping what was established answerable over time." },
];
